<template>
  <div>
    <div class="clearfix mb-4">
      <h4 class="card-title">{{ $t('maintenance.order.addInformation') }}</h4>
    </div>

    <b-card>
      <b-row>
        <b-col md="6">
          <b-form-group id="memo" label="Memo" label-for="memo">
            <b-form-textarea
              id="memo"
              placeholder="Memo"
              rows="3"
              max-rows="6"
              v-model="memo"
              @focus="memoOnFocus = true"
              :disabled="isAllDisabled"
            ></b-form-textarea>
            <div class="d-flex flex-row justify-content-end" v-if="memoOnFocus">
              <b-button
                variant="link"
                class="btn-lg text-success text-decoration-none shadow-none"
                @click="saveMemo"
                ><i class="mc-icon icon-fill_checkmark"></i
              ></b-button>
              <b-button
                variant="link"
                class="btn-lg text-danger text-decoration-none shadow-none"
                @click="cancelMemo"
                ><i class="mc-icon icon-outline_close"></i
              ></b-button>
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <label class="teal-300">{{ $t('maintenance.order.supportDoc') }}</label>
          <b-row>
            <b-col cols="4" xl="2" v-for="index in 5">
              <FormulateInput
                type="file"
                name="file"
                class="mc-input-file"
                accept="application/pdf,image/png,image/jpg,image/jpeg"
                @change="uploadFile($event, index - 1)"
                v-model="documents[index - 1]"
                :key="inputKey"
                v-if="!isAllDisabled || documents[index - 1] != null"
              >
                <template #file="{ file }">
                  <div v-if="isDocumentLoading[index - 1]" style="padding: 25%">
                    <b-spinner label="Spinning"></b-spinner>
                  </div>
                  <div v-else>
                    <div class="formulate-file">
                      <a
                        class="formulate-file-name"
                        :href="file.file.visitUrl"
                        target="_blank"
                        :title="file.name"
                        v-if="file.file.type == 'pdf'"
                      >
                        {{ file.name }}
                      </a>
                      <a
                        href="javascript:void(0)"
                        @click="previewImage(file.file.visitUrl)"
                        class="formulate-file-img d-flex flex-column align-items-center justify-content-center"
                        v-else
                      >
                        <div>
                          <img :src="file.file.visitUrl" :title="file.name" :alt="file.name" />
                        </div>
                        <p>{{ file.name }}</p>
                      </a>
                      <div
                        class="formulate-file-remove"
                        @click="removeFile(index - 1, file.name)"
                      ></div>
                    </div>
                  </div>
                </template>
              </FormulateInput>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modalPreviewImage"
      size="xl"
      centered
      hide-header
      hide-footer
      modal-class="mc-modal-asset"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="mc-modal-preview-banner__wrapper">
        <i class="mc-fa icon-outline_close" @click="closeExample()"></i>
        <img :src="imgPreview" alt="image preview" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import {
  CREATE_SERVICE_ORDER_DOC,
  GET_SERVICE_ORDER_DOCS,
  DELETE_SERVICE_ORDER_DOC,
  UPDATE_SERVICE_ORDER,
} from '@/services/api/maintenance/serviceorder'

export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  props: {
    status: {
      type: String,
      default: 'Draft',
      required: true,
    },
    initMemo: {
      type: String,
      default: '',
    },
    serviceOrderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      memo: this.initMemo,
      oldMemo: this.initMemo,
      memoOnFocus: false,
      inputKey: 0,
      isDocumentLoading: [],
      imgPreview: '',
      isAllDisabled: '',
    }
  },
  watch: {
    status() {
      this.isAllDisabled = this.status == 'Finished'
    },
  },
  async mounted() {
    this.isAllDisabled = this.status == 'Finished'
    await this.$apollo
      .query({
        query: GET_SERVICE_ORDER_DOCS,
        variables: {
          filter: {
            serviceOrderId: this.serviceOrderId,
          },
        },
        fetchPolicy: 'no-cache',
      })
      .then((res) => {
        if (res.data.serviceOrderDocs.isSuccessful) {
          res.data.serviceOrderDocs.serviceOrderDocs.forEach((doc) => {
            this.documents.push([
              {
                url: doc.url.split('?')[0],
                name: doc.fileName,
                uploadAt: doc.uploadAt,
                visitUrl: doc.url,
                type: doc.format,
              },
            ])
          })
          this.inputKey += 1
        } else {
          this.$mcToast.error(res.data.serviceOrderDocs.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    async removeFile(index, filename) {
      this.isDocumentLoading[index] = true
      const res = await this.$apollo
        .mutate({
          mutation: DELETE_SERVICE_ORDER_DOC,
          variables: {
            input: {
              serviceOrderId: this.serviceOrderId,
              fileName: filename,
            },
          },
        })
        .then((res) => {
          if (res.data.deleteServiceOrderDoc.isSuccessful) {
            this.$mcToast.success(res.data.deleteServiceOrderDoc.message)
            this.documents[index] = null
            this.inputKey += 1
          } else {
            this.$mcToast.error(res.data.deleteServiceOrderDoc.message)
          }
        })
      this.isDocumentLoading[index] = false
      return res
    },
    async uploadFile(e, index) {
      try {
        const file = e.target.files[0]
        this.isDocumentLoading[index] = true
        const toBase64 = (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
          })
        const base64 = await toBase64(file)
        await this.$apollo
          .mutate({
            mutation: CREATE_SERVICE_ORDER_DOC,
            variables: {
              input: {
                base64: base64,
                serviceOrderId: this.serviceOrderId,
                fileName: file.name,
                forceUpload: true,
              },
            },
          })
          .then((res) => {
            if (res.data.createServiceOrderDoc.isSuccessful) {
              this.$mcToast.success(res.data.createServiceOrderDoc.message)
              const doc = this.documents[index]
              let newObj = {
                url: res.data.createServiceOrderDoc.createServiceOrderDoc.url.split('?')[0],
                name: res.data.createServiceOrderDoc.createServiceOrderDoc.fileName,
                uploadAt: res.data.createServiceOrderDoc.createServiceOrderDoc.uploadAt,
                visitUrl: res.data.createServiceOrderDoc.createServiceOrderDoc.url,
                type: res.data.createServiceOrderDoc.createServiceOrderDoc.format.replace('.', ''),
                previewData: res.data.createServiceOrderDoc.createServiceOrderDoc.url.split('?')[0],
              }
              doc.files[0].path = newObj
              doc.files[0].file = newObj
              doc.files[0].previewData = doc.files[0].file.url
              doc.files[0].name = newObj.name
            } else {
              this.$mcToast.error(res.data.createServiceOrderDoc.message)
              this.documents[index] = null
            }
          })
          .catch((err) => {
            console.log(err)
            this.documents[index] = null
            this.$mcToast.error('Something went wrong')
          })
          .finally(() => {
            this.isDocumentLoading[index] = false
            this.inputKey += 1
          })
      } catch (err) {
        console.log(err)
        this.isDocumentLoading[index] = false
        this.documents[index] = null
        this.$mcToast.error(err)
      }
    },
    async saveMemo() {
      await this.$apollo
        .mutate({
          mutation: UPDATE_SERVICE_ORDER,
          variables: {
            input: {
              serviceOrderId: this.serviceOrderId,
              oldData: {
                memo: this.oldMemo ?? '',
              },
              newData: {
                memo: this.memo ?? '',
              },
            },
          },
        })
        .then((res) => {
          if (res.data.updateServiceOrder.isSuccessful) {
            this.oldMemo = this.memo
            this.memoOnFocus = false
            this.$mcToast.success(res.data.updateServiceOrder.message)
          } else {
            this.$mcToast.error(res.data.updateServiceOrder.message)
          }
        })
        .catch((err) => {
          this.$mcToast.error(err.message)
        })
    },
    cancelMemo() {
      this.memo = this.oldMemo
      this.memoOnFocus = false
    },
    previewImage(prev_url) {
      this.imgPreview = prev_url
      this.$bvModal.show('modalPreviewImage')
    },
    closeExample() {
      this.imgPreview = null
      this.$bvModal.hide('modalPreviewImage')
    },
  },
}
</script>
